'use strict'

exports.url = () =>{
     //return 'http://localhost:3462/api';
     return 'https://legrafica.mx/api'
}